import React from "react";
import ChangesAccordion from "./ChangesAccordian";
import "./sidebar.scss";
import { Link } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import useDateTime from "../../hooks/useDateTime";
import ReactCountryFlag from "react-country-flag";
import { PayslipStatusMap } from "~/utils/fileUtils";

const StepCard = ({ data, labels, nameLink, endType }) => {
  const { formatDateTime } = useDateTime();

  if (!data) {
    return (
      <div className="mb-5">
        <Skeleton width="8rem" className="mb-2"></Skeleton>
        <Skeleton width="10rem" className="mb-2"></Skeleton>
        <Skeleton className="mb-2"></Skeleton>
        <Skeleton width="10rem" className="mb-2"></Skeleton>
        <Skeleton height="4rem" className="mb-2"></Skeleton>
      </div>
    );
  }

  function handleAction(data) {
    if (endType === "PROCESS" || endType === "SHAREHOLDERS") {
      return handleActionProcess(data.type, data.action);
    } else {
      return handleLabelAction(data.action);
    }
  }

  const handleLabelAction = (action) => {
    const label = labels(data);
    switch (action) {
      case "create":
        return label.create;
      case "update":
        return label.update;
      case "delete":
        return label.delete;
      default:
        return "Invalid action";
    }
  };

  const handleActionProcess = (type, action) => {
    const actionMap = {
      PROCESS: {
        create: "Process Created",
        update: "Process Updated",
        delete: "Process Removed",
      },
      MILESTONE: {
        create: "Milestone Created",
        update: "Milestone Updated",
        delete: "Milestone Removed",
      },
      TASK: {
        create: "Task Created",
        update: "Task Updated",
        delete: "Task Removed",
        flagged: "Task Flagged",
        unflagged: "Task Unflagged",
      },
      CONVERSATION: {
        create: "Message Sent",
        delete: "Message Deleted",
      },
      CONVERSATION_DOCUMENT_DELETE: {
        delete: "Message Deleted (including attachments)",
      },
      DOCUMENT: {
        create: "File Uploaded",
        delete: "File(s) Deleted",
      },
      COMMENTS: {
        create: "Comment Added to a Task",
        delete: "Comment Deleted from a Task",
      },
      SHAREHOLDERS: {
        create: "Shareholder Added",
        update: "Information Updated",
        delete: "Shareholder Deleted",
      },
      PAYSLIPS: {
        create: "Payslip File Uploaded",
        delete: "Payslip/s Deleted",
        approve: "Payslips Matching Edited and submitted",
        submit_reject: "Payslips Matching Edited and submitted",
        reject: "Payslips Delivery Rejected",
        release: "Payslips Delivery Accepted",
      },
    };
    if (type === "AD_HOC" || type === "ESCALATION") {
      return action;
    }
    return actionMap[type]?.[action] || "Invalid action";
  };

  function formatDate(dateStr) {
    return formatDateTime({
      date: dateStr,
      dateformat: "MMMM do, yyyy, h:mm a",
    });
  }

  const name = nameLink ? (
    <Link className="entity-link" to={nameLink(data)}>
      {data.name}
    </Link>
  ) : (
    data.name
  );

  const handleNaming = () => {
    if (endType === "USERACCESS") {
      return (
        <>
          <ReactCountryFlag
            countryCode={data?.country || ""}
            svg
            className=""
          />
          {` ${data?.name} (${data?.country})`}
        </>
      );
    } else if (data?.attachment) {
      return (
        <>
          {data?.name && (
            <>
              <span>{data?.name}</span>
              <br />
            </>
          )}
          <span className="audit-name-space">{data?.attachment}</span>
        </>
      );
    } else {
      return name;
    }
  };
  return (
    <div className="step">
      <h5 className="title m-0 mb-1">{handleAction(data)}</h5>
      <p className="desc-text m-0 mb-1">{handleNaming()}</p>
      {/* only in case of payslips */}
      {data?.type === "PAYSLIPS" &&
        ["approve", "reject", "release", "delete", "submit_reject"].includes(
          data.action,
        ) && (
          <>
            <p className="desc-text m-0 mb-1">{`${data?.employee_name || ""}`}</p>
            <p className="desc-text m-0 mb-1">{`${PayslipStatusMap[data?.match_status] || ""}`}</p>
          </>
        )}
      <p className="desc-text m-0 mb-1">
        {data.actor_name} {data.actor_email ? `(${data.actor_email})` : ""}
      </p>
      <p className="date-time m-0">{formatDate(data.updatedAt)}</p>
      {Object.keys(data.old_data).length ? (
        <ChangesAccordion old_data={data.old_data} new_data={data.new_data} />
      ) : null}
    </div>
  );
};

export default StepCard;
